export type { Options } from './v1';
export { makePersist } from './v1';
export * from './makePersistable';
